import { render, staticRenderFns } from "./CompanyItems.vue?vue&type=template&id=20cd1228&scoped=true"
import script from "./CompanyItems.vue?vue&type=script&lang=js"
export * from "./CompanyItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd1228",
  null
  
)

export default component.exports